//
// Copyright 2024 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import { file_dxos_keys } from "../keys_pb.js";
/**
 * Describes the file dxos/edge/calls.proto.
 */
export const file_dxos_edge_calls = /*@__PURE__*/ fileDesc("ChVkeG9zL2VkZ2UvY2FsbHMucHJvdG8SD2R4b3MuZWRnZS5jYWxscyKEAgoGVHJhY2tzEhIKBWF1ZGlvGAEgASgJSACIAQESGgoNYXVkaW9fZW5hYmxlZBgCIAEoCEgBiAEBEhIKBXZpZGVvGAMgASgJSAKIAQESGgoNdmlkZW9fZW5hYmxlZBgEIAEoCEgDiAEBEhgKC3NjcmVlbnNoYXJlGAUgASgJSASIAQESIAoTc2NyZWVuc2hhcmVfZW5hYmxlZBgGIAEoCEgFiAEBQggKBl9hdWRpb0IQCg5fYXVkaW9fZW5hYmxlZEIICgZfdmlkZW9CEAoOX3ZpZGVvX2VuYWJsZWRCDgoMX3NjcmVlbnNoYXJlQhYKFF9zY3JlZW5zaGFyZV9lbmFibGVkItMCCglVc2VyU3RhdGUSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRIjChZ0cmFuc2NlaXZlcl9zZXNzaW9uX2lkGAMgASgJSACIAQESEwoLcmFpc2VkX2hhbmQYBCABKAgSEAoIc3BlYWtpbmcYBSABKAgSDgoGam9pbmVkGAYgASgIEicKBnRyYWNrcxgHIAEoCzIXLmR4b3MuZWRnZS5jYWxscy5UcmFja3MSPgoKYWN0aXZpdGllcxgIIAMoCzIqLmR4b3MuZWRnZS5jYWxscy5Vc2VyU3RhdGUuQWN0aXZpdGllc0VudHJ5GkwKD0FjdGl2aXRpZXNFbnRyeRILCgNrZXkYASABKAkSKAoFdmFsdWUYAiABKAsyGS5keG9zLmVkZ2UuY2FsbHMuQWN0aXZpdHk6AjgBQhkKF190cmFuc2NlaXZlcl9zZXNzaW9uX2lkInIKCEFjdGl2aXR5EjwKEWxhbXBvcnRfdGltZXN0YW1wGAEgASgLMiEuZHhvcy5lZGdlLmNhbGxzLkxhbXBvcnRUaW1lc3RhbXASKAoHcGF5bG9hZBgKIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QiWwoOTWVldGluZ1BheWxvYWQSEgoKbWVldGluZ19pZBgBIAEoCRIWCg50cmFuc2NyaXB0X2R4bhgCIAEoCRIdChV0cmFuc2NyaXB0aW9uX2VuYWJsZWQYAyABKAgiLwoQTGFtcG9ydFRpbWVzdGFtcBIPCgd2ZXJzaW9uGAEgASgFEgoKAmlkGAIgASgJYgZwcm90bzM", [file_google_protobuf_struct, file_dxos_keys]);
/**
 * Describes the message dxos.edge.calls.Tracks.
 * Use `create(TracksSchema)` to create a new message.
 */
export const TracksSchema = /*@__PURE__*/ messageDesc(file_dxos_edge_calls, 0);
/**
 * Describes the message dxos.edge.calls.UserState.
 * Use `create(UserStateSchema)` to create a new message.
 */
export const UserStateSchema = /*@__PURE__*/ messageDesc(file_dxos_edge_calls, 1);
/**
 * Describes the message dxos.edge.calls.Activity.
 * Use `create(ActivitySchema)` to create a new message.
 */
export const ActivitySchema = /*@__PURE__*/ messageDesc(file_dxos_edge_calls, 2);
/**
 * Describes the message dxos.edge.calls.MeetingPayload.
 * Use `create(MeetingPayloadSchema)` to create a new message.
 */
export const MeetingPayloadSchema = /*@__PURE__*/ messageDesc(file_dxos_edge_calls, 3);
/**
 * Describes the message dxos.edge.calls.LamportTimestamp.
 * Use `create(LamportTimestampSchema)` to create a new message.
 */
export const LamportTimestampSchema = /*@__PURE__*/ messageDesc(file_dxos_edge_calls, 4);
//# sourceMappingURL=calls_pb.js.map